/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from "react";
import { ActionIcon, Group, Image, Text } from "@mantine/core";
import { BrandDiscord, BrandInstagram, BrandTwitter } from "tabler-icons-react";
import { Link } from "react-router-dom";
import { useSinglePrismicDocument } from "@prismicio/react";
import useWindowSize from "../../hooks/useWindowSize";
import config from "../../config/index";

function NavbarLink({ href, label }) {
  return (
    <a
      href={href}
      className="text-2xl opacity-70 no-underline text-white hover:text-main-color hover:opacity-100 active:text-main-color active:opacity-100 text-center"
    >
      {label}
    </a>
  );
}

function MobileMenuItem({ href, label }) {
  return (
    <a
      href={href}
      className="block text-2xl opacity-70 no-underline text-white hover:text-main-color hover:opacity-100 active:text-main-color active:opacity-100 text-center mb-4"
    >
      {label}
    </a>
  );
}
function Navbar() {
  const [menuOpened, setMenuOpened] = useState(false);
  const [document] = useSinglePrismicDocument("header");
  const data = document?.data;

  if (!data) return <></>;
  return (
    <div className="w-full top-0 z-10">
      <div className="flex justify-between items-center p-5 lg:p-8 pt-0">
        <a href="/">
          <Image src={data.logo?.url} height={60} className="mt-2 lg:mt-0" />
        </a>
        <div className="hidden lg:flex lg:items-center lg:gap-7">
          {data.links?.map((link) => {
            let url = link?.link?.url;
            if (url && url.includes("www.shrouded.io/#")) {
              url = url.substring(url.indexOf("#"));
            }
            return <NavbarLink href={url} label={link.label} />;
          })}

          <Group>
            {data.social_links?.map((link) => {
              const logo =
                // eslint-disable-next-line no-nested-ternary
                link.type === "Twitter" ? (
                  <BrandTwitter />
                ) : link.type === "Discord" ? (
                  <BrandDiscord />
                ) : (
                  <BrandInstagram />
                );
              return (
                <ActionIcon
                  component="a"
                  href={link.link.url}
                  target="_blank"
                  variant="outline"
                  size="md"
                >
                  {logo}
                </ActionIcon>
              );
            })}
          </Group>
        </div>
        <img
          className={
            // eslint-disable-next-line prefer-template
            "w-7 h-7 lg:hidden " + (menuOpened ? "hidden" : "block")
          }
          src="hamburger-icon.svg"
          onClick={() => setMenuOpened(true)}
          alt="menu"
        />
        <div
          className={
            // eslint-disable-next-line prefer-template
            "lg:hidden absolute w-full top-0 left-0 z-1 pt-10 px-8 pb-4 box-border bg-black " +
            (menuOpened ? "block" : "hidden")
          }
        >
          <img
            className="w-7 h-7 absolute top-7 right-6"
            src="close.svg"
            onClick={() => setMenuOpened(false)}
            alt="close"
          />
          <MobileMenuItem
            href="https://shroudstaking.shrouded.io/"
            label="Staking"
          />
          <MobileMenuItem href="#about" label="About" />
          <MobileMenuItem href="#roadmap" label="Roadmap" />
          <MobileMenuItem href="#team" label="The Team" />
          <MobileMenuItem href="#gallery" label="Gallery" />
          <MobileMenuItem href="#faq" label="FAQ" />
        </div>
      </div>
    </div>
  );
}

export default Navbar;
